import { AbstractControl } from '@angular/forms';
import { EMAIL_REGEX } from '../constants';

export function emailValidator(control: AbstractControl): { email: true } | null {
  return !control.value || EMAIL_REGEX.test(control.value) ? null : { email: true };
}
